import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollProfileList extends Layout {
    layoutheaderOfficePayrollProfileList: LayoutHeader;
    sourceOfficePayrollProfile: DataSource;
    tableOfficePayrollProfileList: Table;
}
